import { Box, CloseButton, Text } from '@wix/design-system';
import {
  MoneyBackIcon,
  useCurrentModule,
} from '@wix/package-picker-shared-eclipse';
import React from 'react';
import { SaleBanner } from '../SaleBanner';
import { DATA_HOOKS } from './constants';
import s from './QuickPayLightbox.scss';

export const QuickPayPersistentChromeContext = React.createContext(false);

export const useHasQuickPayPersistentChrome = () =>
  React.useContext(QuickPayPersistentChromeContext);

export type QuickPayViewVariant = 'card' | 'flow' | null;

export const QuickPayViewContext =
  React.createContext<QuickPayViewVariant>(null);

export const useQuickPayView = () => React.useContext(QuickPayViewContext);

export interface QuickPayLightboxChromeProps {
  showClose: boolean;

  isCardStep?: boolean;
  onClose: () => void;
}

export const QuickPayLightboxChrome: React.FC<QuickPayLightboxChromeProps> = ({
  showClose,
  isCardStep = true,
  onClose,
}) => {
  const { t } = useCurrentModule().internals.useTranslations();
  const iconSize = isCardStep ? 18 : 24;

  return (
    <Box className={s.chrome} direction="vertical" dataHook={DATA_HOOKS.chrome}>
      <Box className={s.topBar} direction="horizontal" verticalAlign="middle">
        <Box
          flex={1}
          direction="horizontal"
          align="center"
          verticalAlign="middle"
          gap="6px"
          dataHook={DATA_HOOKS.guarantee}
        >
          <MoneyBackIcon width={iconSize} height={iconSize} />
          <Text size="medium" weight="normal" className={s.guaranteeText}>
            {t('premium-purchase-plan.header.strip.money_back')}
          </Text>
        </Box>
        {showClose && (
          <CloseButton
            size="small"
            skin="dark"
            className={s.closeButton}
            dataHook={DATA_HOOKS.close}
            onClick={onClose}
          />
        )}
      </Box>

      <SaleBanner
        urgencyOnly={isCardStep}
        containerProps={{
          className: s.saleBanner,
          paddingTop: '0',
          paddingBottom: '0',
          paddingLeft: '0',
          paddingRight: '0',
          ...(isCardStep ? { borderRadius: '6px' } : {}),
        }}
      />
    </Box>
  );
};
